module.exports = __webpack_public_path__ + "img/regular_lease_process02.819e7893.png";